import { Component, OnInit, Input } from '@angular/core';

import { ViewCell } from '@app/shared/smart-table/ng2-smart-table';
import { ClientService } from '@app/core/client.service';
import { tap } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'app-finca-name',
  template: `
    {{ renderValue }}
  `
})
export class ClienteNameComponent implements OnInit, ViewCell {
  @Input() value: any;
  @Input() rowData: any;

  public renderValue: string;

  constructor(private clienteService: ClientService) {}

  ngOnInit() {
    this.clienteService.data$
      .pipe(
        tap(data => {
          const match = data.find(
            item => String(item?.idCliente) === String(this.value)
          );
          this.renderValue = match?.name || this.value;
        })
      )
      .subscribe();
  }
}
